// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface HcxEnterpriseSitesDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface HcxEnterpriseSitesCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface HcxEnterpriseSitesGetOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface HcxEnterpriseSitesListOptionalParams extends OperationOptions {}
